import { fromTotalMonths } from '@thesavingsgroup/date-utils/fromTotalMonths';
import { isNonNegativeNumber } from '@thesavingsgroup/utils/isNonNegativeNumber';
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';

import { incomeFrequencyFromAPI } from '../../applicantStore/functions/incomeFrequencyFromAPI';
import { isEmployedType } from '../../applicantStore/functions/isEmployedType';
import { reduceIncomeMonthsAt } from '../../applicantStore/functions/reduceIncomeMonthsAt';
import { NO, YES, YesOrNo } from '../../applicantStore/types/YesOrNo';
import { CoapplicantIncomesDto } from '../dto/CoapplicantIncomesDto';
import { CoapplicantState } from '../types/CoapplicantState';

const isCurrentlyEmployed = (
  employmentType?: string | null,
): YesOrNo | null => {
  if (!employmentType) {
    return null;
  }

  return isEmployedType(employmentType) ? YES : NO;
};

export const toCoapplicantStateFromIncomes = (
  income: CoapplicantIncomesDto,
): Partial<CoapplicantState> => {
  const state: Partial<CoapplicantState> = {};

  if (isEmpty(income)) {
    return state;
  }

  if (income.additional) {
    const duration = fromTotalMonths(income.additional.monthsAt);

    state.coapplicantAdditionalIncomeAmount =
      toString(income.additional.amount) || null;
    state.coapplicantAdditionalIncomeDurationMonths =
      duration.months.toString();
    state.coapplicantAdditionalIncomeDurationYears = duration.years.toString();
    state.coapplicantAdditionalIncomeEmployerName =
      income.additional.employerName || null;
    state.coapplicantAdditionalIncomeFrequency = incomeFrequencyFromAPI(
      income.additional.incomeFrequency,
    );
    state.coapplicantAdditionalIncomeJobTitle =
      income.additional.jobTitle || null;
    state.coapplicantAdditionalIncomeType =
      income.additional.additionalIncomeType || null;

    state.hasAdditionalIncome = isNonNegativeNumber(income.additional.amount)
      ? YES
      : NO;
  }

  if (income.current) {
    state.coapplicantCurrentIncomeEmployerName =
      income.current.employerName || null;
    state.coapplicantCurrentIncomeEmploymentType =
      income.current.employmentType || null;
    state.coapplicantCurrentIncomeGrossAnnual =
      toString(income.current.amount) || null;
    state.coapplicantCurrentIncomeJobTitle = income.current.jobTitle || null;

    state.coapplicantCurrentIncomeMonthsAt = toString(
      reduceIncomeMonthsAt(income.current.monthsAt),
    );

    state.isCoapplicantCurrentlyEmployed = isCurrentlyEmployed(
      income.current.employmentType,
    );
  }

  if (income.previous) {
    state.coapplicantPreviousIncomeEmployerName =
      income.previous.employerName || null;
    state.coapplicantPreviousIncomeEmploymentType =
      income.previous.employmentType || null;
    state.coapplicantPreviousIncomeGrossAnnual =
      income.previous.amount.toString() || null;
    state.coapplicantPreviousIncomeJobTitle = income.previous.jobTitle || null;
  }

  return state;
};
